import { request } from '../core';
import BaseOptions from './base';
import { CommonEnumListMapKey } from '@/utils/enum';
import { CommonResponse, EnumListMap } from '@/utils/types';

export interface NeolixAuthData {
  timeStamp?: string;
  access_token?: string;
  signature?: string;
  source?: string;
  nonce?: string;
}

/**
 * 公共接口类
 * @class CommonFetchApi
 * @extends {BaseOptions}
 */
class CommonFetchApi extends BaseOptions {
  /**
   * 获取枚举列表映射接口
   * @param {CommonEnumListMapKey[]} keyList
   * @return {*}  {Promise<CommonResponse<EnumListMap>>}
   * @memberof CommonFetchApi
   */
  public getEnumListMap(
    keyList: CommonEnumListMapKey[]
  ): Promise<CommonResponse<EnumListMap>> {
    const requestOptions = {
      headers: this.requestHeaders,
      method: 'POST',
      absoluteURL: this.fetchDomain + '/monitor/web/enum/get_enum_list_map',
      body: {
        keyList: keyList || []
      }
    };
    return request(requestOptions);
  }
  public checkEnableJKC() {
    const requestOptions = {
      headers: this.requestHeaders,
      method: 'POST',
      absoluteURL: this.fetchDomain + '/schedule/jkc/enableJkc'
    };
    return request(requestOptions);
  }

  /**
   * 获取新石器的权限数据
   * @return {*}  {Promise<CommonResponse<NeolixAuthData>>}
   * @memberof CommonFetchApi
   */
  public getNeolixAuth(): Promise<CommonResponse<NeolixAuthData>> {
    const requestOptions: RequestOptions = {
      absoluteURL:
        this.fetchDomain + '/infrastructure/generalTransport/getNeolixAuth',
      method: 'POST',
      headers: this.requestHeaders
    };
    return request(requestOptions);
  }
}

export const commonFetchApi = new CommonFetchApi();
